import GreenThumbIcon from '../assets/icons/GreenThumbIcon';
import GreyThumbIcon from '../assets/icons/GreyThumbIcon';
import OrangeThumbIcon from '../assets/icons/OrangeThumbIcon';

export const ATTESTATION_STATUS = {
    NOT_REQUESTED: <GreyThumbIcon />,
    REQUESTED: <OrangeThumbIcon />,
    COMPLETED: <GreenThumbIcon />,
};
